<form [formGroup]="form" (ngSubmit)="onSubmit()">

  <div class="p-fluid p-grid">
    <div class="p-field p-col-12 p-md-6 p-offset-3 p-align-center">
      <div>

        <h4>Notificar formula</h4>
      </div>
    </div>
    <div class="p-field p-col-12 p-md-6 p-offset-3">
      <span class="p-float-label">
        <p-dropdown
          inputId="dropdownFabricatne"
          [autoDisplayFirst]="false"
          [options]="fabricantesList"
          formControlName="fabricante"
          [filter]="true"
          [showClear]="true"
          optionLabel="nombre"></p-dropdown>
        <label for="dropdownRol">Fabricante</label>
      </span>
      <small
        id="fabricante-help"
        class="p-error"
        *ngIf="
          form.controls['fabricante'].errors &&
          form.controls['fabricante'].dirty &&
          form.controls['fabricante'].errors['required']
        ">Fabricante es requerido.</small>
    </div>

    <div class="p-field p-col-12 p-md-6 p-offset-3">
      <span class="p-float-label">
        <input
          type="text"
          id="inputtextcolor"
          autocomplete="off"
          pInputText
          formControlName="color" />
        <label for="inputtextcolor">Color</label>
      </span>

      <small
        id="color-help"
        class="p-error"
        *ngIf="
          form.controls['color'].errors &&
          form.controls['color'].dirty &&
          form.controls['color'].errors['required']
        ">Requerido.</small>

      <small
        id="nombre-help"
        class="p-error"
        *ngIf="
          form.controls['color'].errors &&
          form.controls['color'].errors['minlength']
        ">Debe contener al menos 3 caracteres.</small>
    </div>


    <div class="p-field p-col-12 p-md-6 p-offset-3">
      <span class="p-float-label">
        <textarea rows="5" cols="30"
          id="inputtextcomentarios"
          pInputTextarea
          formControlName="comentarios"></textarea>
        <label for="inputtextcomentarios">Comentarios</label>
      </span>

      <small
        id="comentarios-help"
        class="p-error"
        *ngIf="
          form.controls['comentarios'].errors &&
          form.controls['comentarios'].dirty &&
          form.controls['comentarios'].errors['required']
        ">Requerido.</small>

      <small
        id="nombre-help"
        class="p-error"
        *ngIf="
          form.controls['comentarios'].errors &&
          form.controls['comentarios'].errors['minlength']
        ">Debe contener al menos 3 caracteres.</small>
    </div>


  </div>

  <div class="p-grid p-align-center">
    <div class="p-col-2 p-offset-4">
      <button pButton type="button" label="Regresar" class="p-button-raised p-button-secondary"
      icon="pi pi-fw pi-arrow-left"
      (click)="goBack()"></button>
    </div>
    <div class="p-col-2">
      <button pButton type="submit" label="Notificar" class="btn btn-sm btn-primary "
      icon="pi pi-fw pi-envelope"
      [disabled]="!form.valid"></button>
    </div>
  </div>
</form>